import { includes } from 'lodash';

window.Reverb = window.Reverb || {};
Reverb.Listing = Reverb.Listing || {};

Reverb.Listing.Inventory = (function () {
  const TRUE = 'true';
  const conditionField = '#product-condition';
  const hasInventoryField = '#product-has-inventory';
  const inventoryField = '#product-inventory';

  function toggleInventory() {
    const inventorySection = $('[data-show-for-inventory-conditions]');

    toggleSection(inventorySection, canHaveInventory());
    toggleHasInventory();
  }

  function canHaveInventory() {
    const inventoryConditions = $(conditionField).data('inventory-conditions');
    const selectedCondition = $(conditionField).val();
    let canHaveInventory = false;

    if (inventoryConditions) {
      canHaveInventory = includes(inventoryConditions, selectedCondition);
    }

    return canHaveInventory;
  }

  function toggleInventoryOnChange() {
    $(conditionField).change(toggleInventory);
  }

  function toggleHasInventory() {
    const inventorySection = $('[data-show-for-inventoried]');
    const hasInventory = $(hasInventoryField).val() === TRUE;

    toggleSection(inventorySection, hasInventory && canHaveInventory());
  }

  function toggleHasInventoryOnChange() {
    $(hasInventoryField).change(toggleHasInventory);
  }

  function toggleSection(section, condition) {
    const field = section.find('input, select');

    if (condition) {
      field.prop('disabled', false);
      field.trigger('liszt:updated');
      section.fadeIn();
    } else {
      field.prop('disabled', true);
      field.trigger('liszt:updated');
      section.hide();
    }
  }

  function init() {
    toggleInventoryOnChange();
    toggleInventory();

    toggleHasInventoryOnChange();
  }

  return {
    init,
  };
}());

$(Reverb.Listing.Inventory.init);
